import type { EventItem } from '@/types/Event';

export const useEventSchema = (event: EventItem) => {
  return {
    '@context': 'https://schema.org',
    '@type': 'SportsEvent',
    name: event.name,
    startDate: event.startDate,
    endDate: event.endDate,
    location:
      event.type === 'online'
        ? { '@type': 'VirtualLocation', url: event.eventLink }
        : {
            '@type': 'Place',
            name: event.location || 'À déterminer',
            address: event.location,
          },
    eventAttendanceMode:
      event.type === 'online'
        ? 'https://schema.org/OnlineEventAttendanceMode'
        : 'https://schema.org/OfflineEventAttendanceMode',
    eventStatus: 'https://schema.org/EventScheduled',
    url: event.eventLink,
    sport: 'CrossFit',
    organizer: { '@type': 'Organization', name: event.source },
  };
};
